import { FormattedMessage } from "react-intl";
import { Button, NewReceipt, NewReceiptSkeleton } from "@letsbit/milkylb";
import React, { useState } from "react";

import { HistoryDownloadReceiptProps } from "./types";
import { messages } from "./messages";
import { useGetDataForReceipt } from "components/HistoryInfiniteScroll/HistoryDetails/components/HistoryDownloadReceipt/useGetDataForReceipt";
import { useMakeReceipt } from "hooks/utils/useMakeReceipt";

import "./styles.scss";

const FILE_NAME = "Comprobante de operación ";

export const HistoryDownloadReceipt: React.FC<HistoryDownloadReceiptProps> = (
  props,
) => {
  const [loading, setLoading] = useState(false);
  const { makePdf } = useMakeReceipt();

  const { showSkeleton, title, date, amount, from, to, extras } =
    useGetDataForReceipt(props);

  const generatePDF = async (filename = "receipt") => {
    try {
      setLoading(true);

      await makePdf(filename, "receipt");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      isLoading={loading || showSkeleton}
      className="history-download-receipt pdf:hidden"
      fill="clear"
      onClick={() => {
        generatePDF(FILE_NAME + props.movement.tid);
      }}
    >
      <div style={{ display: "none" }}>
        {showSkeleton ? (
          <NewReceiptSkeleton />
        ) : (
          <NewReceipt
            id="receipt"
            title={title}
            date={date}
            amount={amount}
            from={from}
            to={to}
            extras={extras}
            className="history-download-receipt__receipt"
          />
        )}
      </div>
      <FormattedMessage {...messages.downloadButton} />
    </Button>
  );
};
